// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"7d1e11e2","253":"aa6b3664","380":"8846a739","394":"e36e9b8a","420":"bee05ef6","450":"8a3f661e","657":"fbdcc8da","865":"24b2b1ec","890":"c7d7c232","892":"8d98e1f3","927":"dc85d4e8"}[chunkId] + ".chunk.js";
};